"use client";

import { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";
import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

export const packCodesInputs = [
  {
    name: "title",
    type: "string",
    required: true,
    defaultValue: "Submit your pack codes and earn points",
  },
  {
    name: "background",
    type: "file",
    friendlyName: "Background image",
    allowedFileTypes: IMAGE_FILE_TYPES,
    required: true,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F0c66bd2bcef642ed87237f2931971661",
  },
  {
    name: "mobileHeaderImage",
    type: "file",
    friendlyName: "Mobile top image",
    allowedFileTypes: IMAGE_FILE_TYPES,
    required: true,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fbb0b0eb428b34d65b6c9da2ab69b00f8",
  },
  {
    name: "mobileBottomImage",
    type: "file",
    friendlyName: "Mobile bottom image",
    allowedFileTypes: IMAGE_FILE_TYPES,
    required: true,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fb39384b51f384a5daea3c67aca8a083e",
  },
  {
    name: "loggedInDescription",
    type: "richText",
    friendlyName: "Description for logged in users",
    required: true,
    defaultValue:
      '<p>You’ll find a unique code inside each of our <a href="#">flavors packs</a>. Scan up to 5 pack codes per week to earn points. Simply sign-in and enter them here to earn Ploom Club points and redeem fantastic rewards. Message for Logged in Users.</p>\r\n',
  },
  {
    name: "loggedOutDescription",
    friendlyName: "Description for logged out users",
    type: "richText",
    required: true,
    defaultValue:
      '<p>You’ll find a unique code inside each of our <a href="#">flavors packs</a>. Scan up to 5 pack codes per week to earn points. Simply sign-in and enter them here to earn Ploom Club points and redeem fantastic rewards.</p>\r\n',
  },
  {
    name: "limitText",
    type: "string",
    friendlyName: "Limit Information",
    required: true,
    defaultValue: "You can claim up to 5 codes per week.",
  },
  {
    name: "limitTextReached",
    type: "richText",
    friendlyName: "Limit reached text",
    required: true,
    defaultValue:
      '<p>You have reached the limit of 5 codes for this week. Please try again later. <a href="#">Link Test</a></p>\r\n',
  },
  {
    name: "inputPlaceholder",
    type: "string",
    friendlyName: "Input Placeholder Text",
    required: true,
    defaultValue: "Your code here",
  },
  {
    name: "buttonTitle",
    type: "string",
    friendlyName: "Submit Button Text",
    required: true,
    defaultValue: "Submit",
  },
  {
    name: "confirmationTitle",
    type: "string",
    friendlyName: "Confirmation Title for submitted code",
    required: true,
    defaultValue: "Code submitted successfully.",
  },
  {
    name: "errorCodeMessage",
    type: "richText",
    friendlyName: "Invalid Code Error Message",
    required: true,
    defaultValue:
      '<p>This code has already been used. Please try again. Need help? <a href="#">With a link.</a></p>\r\n',
  },
  {
    name: "errorEarningMessage",
    type: "richText",
    friendlyName: "Invalid Code Earning Message",
    required: true,
    defaultValue:
      '<p>An error has occurred. Contact admins for more info. <a href="#">With a link.</a></p>\r\n',
  },
  {
    name: "bottomMessageHistory",
    type: "string",
    friendlyName: "View History Text",
    required: true,
    defaultValue: "View your earned pack codes history",
  },
  {
    name: "bottomMessageHistoryLink",
    type: "string",
    friendlyName: "Hyperlink for History Text",
    required: true,
    defaultValue: "/content/ploom/automation/en/loyalty",
  },
  {
    name: "packCodeName",
    type: "string",
    friendlyName: "Pack code name",
    required: true,
    defaultValue: "Pack Code.",
  },
  {
    name: "packCodeText",
    type: "string",
    friendlyName: "Extra details",
    required: true,
    defaultValue: "Where can I find it?",
  },
  {
    name: "packCodeLink",
    type: "string",
    friendlyName: "Hyperlink for Extra Details",
    required: true,
    defaultValue: "/content/ploom/automation/en",
  },
  {
    name: "earningMessage",
    type: "string",
    friendlyName: "Message with earning info",
    required: true,
    defaultValue: "You have earned {#points#} points.",
  },
  {
    name: "headerLogo",
    type: "file",
    friendlyName: "Header Logo",
    required: true,
    defaultValue:
      "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2F1ee41566ad9d4c978d68fd13d262bcec",
  },
  {
    name: "componentTitle",
    type: "string",
    friendlyName: "Header Title",
    required: true,
    defaultValue: "PACK CODES",
  },
  {
    name: "closeButtonText",
    type: "string",
    required: false,
    defaultValue: "Close",
  },
  {
    name: "restrictedContent",
    type: "boolean",
    friendlyName:
      "Use restricted content for logged in users who did not join Loyalty program",
    required: false,
    defaultValue: false,
  },
  {
    name: "restrictedTitle",
    type: "string",
    friendlyName: "Title for restricted users",
    required: true,
    defaultValue: "Default Restricted Title",
  },
  {
    name: "restrictedDescription",
    type: "string",
    friendlyName: "Description for restricted users",
    required: true,
    defaultValue: "Default Restricted Description",
  },
  {
    name: "restrictedCta",
    type: "string",
    friendlyName: "Label for CTA for restricted users",
    required: true,
    defaultValue: "Check it",
  },
  {
    name: "restrictedCtaUrl",
    type: "url",
    friendlyName: "Url for CTA for restricted users",
    required: true,
    defaultValue: "#",
  },
  {
    name: "signInTitle",
    type: "string",
    friendlyName: "Label for sign in CTA",
    required: true,
    defaultValue: "Sign in",
  },
  {
    name: "signInUrl",
    type: "url",
    friendlyName: "Url for sign in CTA",
    required: true,
    defaultValue: "#",
  },
  {
    name: "registerTitle",
    type: "string",
    friendlyName: "Label for sign up CTA",
    defaultValue: "Create an account",
  },
  {
    name: "registerUrl",
    type: "url",
    friendlyName: "Url for sign up CTA",
    defaultValue: "#",
  },
] as const satisfies Inputs;

export const PackCodesComponent: RegisteredComponent = {
  name: "PackCodes",
  component: dynamic(async () =>
    withValidation(
      packCodesInputs,
      (await import("./PackCodes")).PackCodes,
      "PackCodes"
    )
  ),
  inputs: packCodesInputs,
};
